import { useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { FormProvider } from '@app/components';
import { BankInformationForm } from '@app/sections/shared/bank-info-form';
import { IAddBankInformatinSchema, IMyProfileResponse } from '../types';
import { bankInformationSchema } from '../validators';
import { updateProfile } from './slice';

interface Props {
  row?: IMyProfileResponse;
}

const BankInformationPage = ({ row }: Props) => {
  const dispatch = useDispatch();
  const methods = useForm<IAddBankInformatinSchema>({
    resolver: yupResolver(bankInformationSchema) as any,
    defaultValues: {
      bankInfo: {
        bankInformation: {
          accountHolderName: row?.bankInformation?.accountHolderName,
          fatherName: row?.bankInformation?.fatherName,
          bankName: row?.bankInformation?.bankName,
          ifscCode: row?.bankInformation?.ifscCode,
          accountType: row?.bankInformation?.accountType,
          accountNumber: row?.bankInformation?.accountNumber,
          reenterAccountNumber: row?.bankInformation?.reenterAccountNumber,
        },
      },
    },
  });

  const onSubmit = (form: IAddBankInformatinSchema) => {
    dispatch(updateProfile({ bankInfo: { ...form }, id: row?.id }));
  };
  return (
    <>
      <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
        <BankInformationForm
          labelSuffix
          additionalButton={
            <Button
              variant="outlined"
              color="inherit"
              size="large"
              sx={{ width: 'max-content' }}
              type="submit"
            >
              {Strings.button.saveBankInformation}
            </Button>
          }
        />
      </FormProvider>
    </>
  );
};
export { BankInformationPage };
